import { connect } from 'react-redux';

import {
  getOfficeDetails,
  getOfficesShortList,
} from '../../OfficesNew/officesActions';
import {
  getOrganizationMembersList,
  getOrganizationMembersShortList,
} from '../../Projects/projectsActions';
// Actions
import {
  clearTimesheetList,
  getDailyTimesheets,
  getOtherTimesheets,
} from '../timesheetActions';
// Component
import TimesheetBiweekly from './TimesheetBiweekly';

// Store props to map with current state
const mapStateToProps = state => ({
  isLoading: state.timesheet.isLoading,
  dailyTimesheetLoading: state.timesheet.dailyTimesheetLoading,

  dailyTimesheets: state.timesheet.dailyList,
  timesheetsList: state.timesheet.list,

  selectedOrganization: state.organization.selectedOrganization,
  profileData: state.profile.profileData,
  //office
  officesShortList: state.office.officesShortList,
  officeDetails: state.office.officeDetails,
  //member short list
  orgMembersShortList: state.project.orgMembersShortList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  filters: state.filterReducer.filters,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getDailyTimesheets: payload => dispatch(getDailyTimesheets(payload)),
  getOtherTimesheets: payload => dispatch(getOtherTimesheets(payload)),
  getOrganizationMembersList: payload =>
    dispatch(getOrganizationMembersList(payload)),
  getOrganizationMembersShortList: params =>
    dispatch(getOrganizationMembersShortList(params)),
  clearTimesheetList: () => dispatch(clearTimesheetList()),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getOfficeDetails: payload => dispatch(getOfficeDetails(payload)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(TimesheetBiweekly);
